// extracted by mini-css-extract-plugin
module.exports = {"dynamicInput":"DynamicTitleInput_dynamicInput__1DSv8","big":"DynamicTitleInput_big__2uJfN","normal":"DynamicTitleInput_normal__35y0O","small":"DynamicTitleInput_small__2UkT9"};